import $ from 'jquery';
import { generateIconElement, ICON } from "../../Icons/Icons";

/**
 * BuyNewPremiumSpacesModal - A component for showing modal when user needs to buy more premium spaces
 */
class BuyNewPremiumSpacesModal {
  /**
   * Get the modal template
   * @returns {string} HTML template
   */
  modalTemplate() {
    return `
<div class="confirm-modal confirm-modal--light-theme middle space-select-modal">
  <div class="confirm-dialog">
    ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
    
    <div class="space-select-modal__title" data-lang="buy-premium-spaces-title">
      Do you want to buy more Premium Spaces?
    </div>
    
    <div class="confirm-footer my-5">
      <button id="cancel_buy_premium" class="buttn secondary" data-lang="cancel-text">
        Cancel
      </button>
      
      <button id="buy_more_premium" class="buttn primary" data-lang="buy-more-text">
        Buy more
      </button>
    </div>
    
    <div class="space-select-modal__plan-comparison-link">
      <a href="#" id="show_plan_comparison_buy" data-lang="show-plan-comparison">
        Show me the Plan Comparison page
      </a>
    </div>
  </div>
</div>
    `;
  }

  /**
   * Constructor
   * @param {Object} options - Configuration options
   */
  constructor(options = {}) {
    this.subscriptionUrl = options.subscriptionUrl || '/myprofile/subscriptions';
    this.planComparisonUrl = options.planComparisonUrl || '/plans';

    this.render();
    this.addEventListeners();
  }

  /**
   * Render the modal
   */
  render() {
    this.$modal = $(this.modalTemplate());
    $('body').append(this.$modal);

    this.$elements = {
      $cancelBuyPremium: this.$modal.find('#cancel_buy_premium'),
      $buyMorePremium: this.$modal.find('#buy_more_premium'),
      $showPlanComparison: this.$modal.find('#show_plan_comparison_buy'),
      $close: this.$modal.find('.confirm-close')
    };
  }

  /**
   * Add event listeners
   */
  addEventListeners() {
    // Cancel button - hide modal
    this.$elements.$cancelBuyPremium.on('click', () => {
      this.hide();
    });

    // Close button - hide modal
    this.$elements.$close.on('click', () => {
      this.hide();
    });

    // Buy more button - redirect to subscription page
    this.$elements.$buyMorePremium.on('click', () => {
      window.location.href = this.subscriptionUrl;
    });

    // Plan comparison link - redirect to plans page
    this.$elements.$showPlanComparison.on('click', (e) => {
      e.preventDefault();
      window.location.href = this.planComparisonUrl;
    });

    // Click outside modal to close
    this.$modal.on('click', (e) => {
      if (e.target === this.$modal[0]) {
        this.hide();
      }
    });
  }

  /**
   * Show the modal
   */
  show() {
    this.$modal.addClass('visible').show();
  }

  /**
   * Hide the modal
   */
  hide() {
    this.$modal.removeClass('visible').hide();
  }

  /**
   * Destroy the modal and remove from DOM
   */
  destroy() {
    if (this.$modal) {
      this.$modal.remove();
    }
  }
}

export default BuyNewPremiumSpacesModal;
